// extracted by mini-css-extract-plugin
export default {"mainWrapper":"MainWrapper_mainWrapper__8psMV"};